import {
  Injectable
} from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import {
  AccountService
} from '@app/_services';
@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {
  savedVar: any;
  constructor(
    private router: Router,
    private accountService: AccountService
  ) {}
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    this.savedVar = localStorage.getItem('saved'); //300 sec = 5 minutes
    let expiryTime = new Date().getTime() - this.savedVar;
    if (this.savedVar && (expiryTime > 30 * 60 * 1000)) {
      console.log();
      localStorage.removeItem('token');
      localStorage.removeItem('users');
      localStorage.removeItem('saved');
      localStorage.removeItem('username');
    }
    if (localStorage.getItem('token') != '' && localStorage.getItem('token') != null && typeof (localStorage.getItem('token')) != undefined) {
      // authorised so return true
      return true;
    }
    // not logged in so redirect to login page with the return url
    this.router.navigate(['/account/login'], {
      queryParams: {
        returnUrl: state.url
      }
    });
    return false;
  }
}
